import {
  Box,
  Button,
  Flex,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Text,
  Textarea,
  useDisclosure,
} from "@chakra-ui/react";
import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/tabs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getGreetingSentDetails,
  sendGreetingsDiary,
  getGreetingReceiveDetails,
} from "../../../Redux/App/action";
import { IoIosAddCircle } from "react-icons/io";
import close from "../../../assets/buttons/close.png";
const GreetingCard = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();
  const [guestName, setguestName] = useState("");
  const [guestPhoneNumber, setguestPhoneNumber] = useState("");
  const [guestEmail, setguestEmail] = useState("");
  const [specialNote, setspecialNote] = useState("");
  const [customizedTemplateId, setcustomizedTemplateId] = useState(0);
  const { allSentGreetings, allReceiveGreeting, isLoading } = useSelector(
    (store) => store.appReducer,
  );
  useEffect(() => {
    dispatch(getGreetingSentDetails);
  }, []);
  useEffect(() => {
    dispatch(getGreetingReceiveDetails);
  }, []);
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const handleSendGreetings = () => {
    const formData = new FormData();
    formData.append(
      "greetingsDetails[0].customizedTemplateId",
      customizedTemplateId,
    );
    formData.append("specialNote", specialNote);
    formData.append("greetingsDetails[0].guestName", guestName);
    formData.append("greetingsDetails[0].guestPhoneNumber", guestPhoneNumber);
    formData.append("greetingsDetails[0].guestEmail", guestEmail);
    dispatch(sendGreetingsDiary(formData));
  };
  const Loader = () => {
    return (
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        background="rgba(0, 0, 0, 0.5)"
        zIndex="9999"
      >
        <Spinner size="xl" color="blue.500" thickness="4px" />
      </Box>
    );
  };
  if (isLoading) {
    return (
      <Box h={"80vh"}>
        <Loader />
      </Box>
    );
  }
  return (
    <>
      <Tabs p={2} mb={10}>
        <TabList mb="1em">
          <Tab w={"50%"} borderRadius={14}>
            <Flex
              alignItems={"center"}
              gap={{ md: 20, base: 0 }}
              justifyContent={"center"}
              fontWeight={"bold"}
              fontSize={{ md: 18, base: 16 }}
            >
              Greetings Sent{" "}
              <IoIosAddCircle size={20} color="green" onClick={onOpen} />
            </Flex>
          </Tab>
          <Tab w={"50%"} borderRadius={14}>
            <Flex
              alignItems={"center"}
              gap={{ md: 20, base: 0 }}
              justifyContent={"center"}
              fontWeight={"bold"}
              fontSize={{ md: 18, base: 16 }}
            >
              Greetings Receive
            </Flex>
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <Box
              display={"grid"}
              gridTemplateColumns={{
                md: "repeat(2,1fr)",
                base: "repeat(1,1fr)",
              }}
              gap={4}
            >
              {allSentGreetings &&
                allSentGreetings.map((el, i) => (
                  <Box key={i}>
                    {el.toText &&
                      el.toText.map((ele, index) => (
                        <Flex
                          borderRadius={10}
                          gap={{ md: 2, base: 0 }}
                          textAlign={"left"}
                          flexDirection={{
                            base: "column",
                            md: "row",
                          }}
                          boxShadow={
                            "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;"
                          }
                          key={index}
                        >
                          <Image
                            src={el.img}
                            w={{
                              md: "10%",
                              base: "50%",
                            }}
                            borderRadius={10}
                            m={{
                              base: "auto",
                              md: "0",
                            }}
                            h={{
                              base: 200,
                              md: "65px",
                            }}
                          />
                          <Box
                            w={{
                              md: "44%",
                              base: "90%",
                            }}
                            px={5}
                            py={2}
                          >
                            <Text
                              fontWeight={"semibold"}
                              fontSize={{
                                md: 14,
                                base: 12,
                              }}
                            >
                              Invitation Status:{" "}
                              <span
                                style={{
                                  color: "#FC1A64",
                                }}
                              >
                                "PENDING"
                              </span>
                            </Text>
                            <Text
                              mt={2}
                              fontWeight={"semibold"}
                              fontSize={{
                                md: 14,
                                base: 12,
                              }}
                            >
                              Guest Name:
                              <span
                                style={{
                                  color: "green",
                                }}
                              >
                                {ele.guestName}
                              </span>
                            </Text>
                          </Box>
                          <Flex
                            w={"44%"}
                            px={5}
                            py={2}
                            flexDirection={{
                              md: "column",
                              base: "row",
                            }}
                            gap={{
                              md: 0,
                              base: "24%",
                            }}
                          >
                            <Text
                              fontWeight={"semibold"}
                              fontSize={{
                                md: 14,
                                base: 12,
                              }}
                            >
                              {ele.guestPhoneNumber}
                            </Text>
                            <Text
                              mt={{
                                md: 2,
                                base: 0,
                              }}
                              fontWeight={"semibold"}
                              fontSize={{
                                md: 14,
                                base: 12,
                              }}
                              color={"#1492E6"}
                            >
                              {ele.guestEmail}
                            </Text>
                          </Flex>
                        </Flex>
                      ))}
                  </Box>
                ))}
            </Box>
            <Modal
              initialFocusRef={initialRef}
              finalFocusRef={finalRef}
              isOpen={isOpen}
              onClose={onClose}
            >
              <ModalOverlay />
              <ModalContent
                borderRadius={0}
                w={{ md: "30%", base: "98%" }}
                textAlign={"left"}
              >
                <ModalHeader>
                  <Flex alignItems={"center"} justifyContent={"space-between"}>
                    SEND GREETINGS{" "}
                    <Image
                      src={close}
                      w={"18%"}
                      onClick={onClose}
                      cursor={"pointer"}
                    />
                  </Flex>
                </ModalHeader>
                <ModalBody pb={6} borderRadius={0}>
                  <Flex alignItems={"center"} justifyContent={"center"} pr={5}>
                    <Text
                      w={"50%"}
                      color={"#3E3E3E"}
                      fontSize={16}
                      fontWeight={"semibold"}
                    >
                      Guest Name
                      <span style={{ color: "#FC1A64" }}>*</span>{" "}
                    </Text>
                    <Input
                      border={0}
                      borderBottom={"1px solid gray"}
                      type="text"
                      onChange={(e) => {
                        const sanitizedValue = e.target.value.replace(
                          /[^a-zA-Z\s]/g,
                          "",
                        );
                        setguestName(sanitizedValue);
                      }}
                      ref={initialRef}
                      name="guestName"
                      value={guestName}
                      borderRadius={0}
                      mt={"-8%"}
                      w={"70%"}
                      focusBorderColor="transparent"
                      _focusVisible={false}
                    />
                  </Flex>
                  <Flex
                    alignItems={"center"}
                    justifyContent={"center"}
                    pr={5}
                    mt={4}
                  >
                    <Text
                      w={"50%"}
                      color={"#3E3E3E"}
                      fontSize={16}
                      fontWeight={"semibold"}
                    >
                      Mobile Number
                      <span style={{ color: "#FC1A64" }}>*</span>{" "}
                    </Text>
                    <Input
                      border={0}
                      borderBottom={"1px solid gray"}
                      type="number"
                      name="guestPhoneNumber"
                      value={guestPhoneNumber}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue.length <= 10) {
                          setguestPhoneNumber(inputValue);
                        }
                      }}
                      borderRadius={0}
                      mt={"-8%"}
                      maxLength={10}
                      w={"70%"}
                      focusBorderColor="transparent"
                      _focusVisible={false}
                    />
                  </Flex>
                  <Flex
                    alignItems={"center"}
                    justifyContent={"center"}
                    pr={5}
                    mt={4}
                  >
                    <Text
                      w={"50%"}
                      color={"#3E3E3E"}
                      fontSize={16}
                      fontWeight={"semibold"}
                    >
                      Guest Email
                      <span style={{ color: "#FC1A64" }}>*</span>{" "}
                    </Text>
                    <Input
                      border={0}
                      borderBottom={"1px solid gray"}
                      type="email"
                      name="guestEmail"
                      value={guestEmail}
                      onChange={(e) => {
                        const sanitizedValue = e.target.value.replace(
                          /[^a-zA-Z@.]/g,
                          "",
                        );
                        setguestEmail(e.target.value);
                      }}
                      borderRadius={0}
                      mt={"-8%"}
                      w={"70%"}
                      focusBorderColor="transparent"
                      _focusVisible={false}
                    />
                  </Flex>
                  <Flex
                    alignItems={"center"}
                    justifyContent={"center"}
                    pr={5}
                    mt={4}
                  >
                    <Text
                      w={"50%"}
                      color={"#3E3E3E"}
                      fontSize={16}
                      fontWeight={"semibold"}
                    >
                      Special Note
                      <span style={{ color: "#FC1A64" }}>*</span>{" "}
                    </Text>
                    <Textarea
                      border={0}
                      borderBottom={"1px solid gray"}
                      type="text"
                      name="specialNote"
                      value={specialNote}
                      onChange={(e) => {
                        const sanitizedValue = e.target.value.replace(
                          /[^a-zA-Z\s]/g,
                          "",
                        );
                        setspecialNote(sanitizedValue);
                      }}
                      borderRadius={0}
                      mt={"-8%"}
                      w={"70%"}
                      focusBorderColor="transparent"
                      _focusVisible={false}
                    />
                  </Flex>
                  <Button
                    bg={"#FC1A64"}
                    w={"90%"}
                    color={"white"}
                    fontWeight={"bold"}
                    borderRadius={5}
                    m={"auto"}
                    mt={"10%"}
                    onClick={handleSendGreetings}
                  >
                    SELECT A GREETING CARD
                  </Button>
                </ModalBody>
              </ModalContent>
            </Modal>
          </TabPanel>
          <TabPanel>
            <Box
              display={"grid"}
              gridTemplateColumns={{
                md: "repeat(2,1fr)",
                base: "repeat(1,1fr)",
              }}
              gap={4}
            >
              {allReceiveGreeting &&
                allReceiveGreeting.map((el, i) => (
                  <Box key={i}>
                    {el.toText &&
                      el.toText.map((ele, index) => (
                        <Flex
                          borderRadius={10}
                          gap={{ md: 2, base: 0 }}
                          textAlign={"left"}
                          flexDirection={{
                            base: "column",
                            md: "row",
                          }}
                          boxShadow={
                            "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;"
                          }
                          key={index}
                        >
                          <Image
                            src={el.img}
                            w={{
                              md: "10%",
                              base: "50%",
                            }}
                            borderRadius={10}
                            m={{
                              base: "auto",
                              md: "0",
                            }}
                            h={{
                              base: 200,
                              md: "65px",
                            }}
                          />
                          <Box
                            w={{
                              md: "44%",
                              base: "90%",
                            }}
                            px={5}
                            py={2}
                          >
                            <Text
                              fontWeight={"semibold"}
                              fontSize={{
                                md: 14,
                                base: 12,
                              }}
                            >
                              Invitation Status:{" "}
                              <span
                                style={{
                                  color: "#FC1A64",
                                }}
                              >
                                "PENDING"
                              </span>
                            </Text>
                            <Text
                              mt={2}
                              fontWeight={"semibold"}
                              fontSize={{
                                md: 14,
                                base: 12,
                              }}
                            >
                              Guest Name:
                              <span
                                style={{
                                  color: "green",
                                }}
                              >
                                {ele.guestName}
                              </span>
                            </Text>
                          </Box>
                          <Flex
                            w={"44%"}
                            px={5}
                            py={2}
                            flexDirection={{
                              md: "column",
                              base: "row",
                            }}
                            gap={{
                              md: 0,
                              base: "24%",
                            }}
                          >
                            <Text
                              fontWeight={"semibold"}
                              fontSize={{
                                md: 14,
                                base: 12,
                              }}
                            >
                              {ele.guestPhoneNumber}
                            </Text>
                            <Text
                              mt={{
                                md: 2,
                                base: 0,
                              }}
                              fontWeight={"semibold"}
                              fontSize={{
                                md: 14,
                                base: 12,
                              }}
                              color={"#1492E6"}
                            >
                              {ele.guestEmail}
                            </Text>
                          </Flex>
                        </Flex>
                      ))}
                  </Box>
                ))}
            </Box>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
};

export default GreetingCard;
